import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import styles from "./Pagination.module.css";
export const Pagination = ({ currentPage, totalPages, pageSize, onPageChange, }) => {
    const [jumpToPage, setJumpToPage] = useState("");
    // Calculate visible page range (show 5 pages max)
    const getPageRange = () => {
        let start = Math.max(1, currentPage - 2);
        let end = Math.min(totalPages, currentPage + 2);
        // Adjust if near the beginning or end
        if (currentPage <= 2) {
            end = Math.min(5, totalPages);
        }
        else if (currentPage >= totalPages - 1) {
            start = Math.max(1, totalPages - 4);
        }
        return { start, end };
    };
    const { start, end } = getPageRange();
    const pages = Array.from({ length: end - start + 1 }, (_, i) => start + i);
    const handleJumpToPage = (e) => {
        e.preventDefault();
        const page = parseInt(jumpToPage);
        if (page >= 1 && page <= totalPages) {
            onPageChange(page);
            setJumpToPage("");
        }
    };
    return (_jsxs("div", { className: styles.paginationWrapper, children: [_jsxs("span", { className: styles.paginationDesc, children: ["Showing ", pageSize, " on page ", currentPage, " of ", totalPages, " pages"] }), _jsxs("div", { className: styles.paginationControls, children: [pages.map((page) => (_jsx("button", { onClick: () => onPageChange(page), className: `${styles.pageBtn} ${currentPage === page ? styles.active : ""}`, children: page }, page))), _jsxs("form", { onSubmit: handleJumpToPage, className: styles.jumpForm, children: [_jsx("input", { type: "number", min: "1", max: totalPages, value: jumpToPage, onChange: (e) => setJumpToPage(e.target.value), placeholder: "Page", className: styles.jumpInput }), _jsx("button", { type: "submit", className: styles.goBtn, children: "Go" })] })] })] }));
};
